import React from 'react'
import Helmet from 'react-helmet-async'
import { compose, Mutation } from 'react-apollo'

import { UPDATE_CREDIT } from '../../graphql/mutations'

import GetUser from '../../hocs/queries/GetUser'
import GetProject from '../../hocs/queries/GetProject'
import GetSession from '../../hocs/queries/GetSession'
import { GetCreditRefreshed } from '../../hocs/queries/GetCredit'

// Our Base Components
import Breadcrumb from '../../components/Breadcrumb'
import CreditForm from '../../components/CreditForm'
import SectionContainer from '../../components/SectionContainer'
import CreatePagesHeader from '../../components/CreatePagesHeader'

class SessionCreditEdit extends React.Component {
  render() {
    return (
      <>
        <Helmet>
          <title>
            Create Credit | {this.props.project.name} | {this.props.session.name}
          </title>
        </Helmet>
        <main className='main'>
          <CreatePagesHeader
            title={`Edit Credit of ${this.props.session.name}`}
            subtitle='Edit Credit Details'>

            <Breadcrumb
              items={[
                {
                  href: `/projects`,
                  name: 'Projects'
                },
                {
                  href: `/projects/${this.props.project.id}`,
                  name: this.props.project.name
                },
                {
                  href: `/projects/${this.props.project.id}/sessions`,
                  name: 'Project Sessions'
                },
                {
                  href: `/projects/${this.props.project.id}/sessions/${this.props.session.id}`,
                  name: this.props.session.name
                },
                {
                  href: `/projects/${this.props.project.id}/sessions/${
                    this.props.session.id
                  }#credits`,
                  name: 'Session Credits'
                },
                {
                  href: `/projects/${this.props.project.id}/sessions/${
                    this.props.session.id
                  }/credits/${this.props.credit.id}/edit`,
                  name: 'Edit Session Credit'
                }
              ]}
            />
          </CreatePagesHeader>

          <div className='sections-container'>
            <SectionContainer>
              <Mutation
                mutation={UPDATE_CREDIT}
                update={() => {
                  this.props.history.push(
                    `/projects/${this.props.project.id}/sessions/${
                      this.props.session.id
                    }#credits`
                  )
                }}
              >
                {(updateCredit, { loading, error }) => (
                  <CreditForm
                    {...this.props.credit}
                    projectId={this.props.project.id}
                    onSubmit={state => {
                      let data = { ...state }
                      Object.keys(data).forEach(key => data[key] === '' && (data[key] = null))
                      updateCredit({
                        variables: {
                          ...data,
                          creditId: this.props.credit.id,
                          performing: data.performing ? true : false
                        }
                      }).catch(() => {
                        //
                      })
                    }}
                    loading={loading}
                    errors={error}
                    discardForm={true}
                  />
                )}
              </Mutation>
            </SectionContainer>
          </div>
        </main>
      </>
    )
  }
}

export default compose(
  GetUser,
  GetProject,
  GetSession,
  GetCreditRefreshed
)(SessionCreditEdit)
